import { Modal, Stack, Typography } from '@mui/joy';
import React, { FC } from 'react';

const LoadingModal: FC<{ open: boolean }> = ({ open }) => {
  return (
    <Modal open={open}>
      <Stack
        justifyContent={'center'}
        alignItems={'center'}
        height={'100%'}
        rowGap={3}
        sx={{
          '&:focus-visible': {
            outline: 'none',
          },
        }}>
        <img src="/ybrain.svg" width={100} alt="loading..." className="heart" />
        <Typography color={'primary'}>Loading...</Typography>
      </Stack>
    </Modal>
  );
};

export default LoadingModal;
